import { BookingStatusNames, IBookingStatus } from 'shared-types/bookingStatusTypes';
import { IBooking, IBookingTime, ITableItem } from 'shared-types/SharedTypes';

export interface IStandbyListState {
  isManualJoin: boolean;
  isLoading: boolean;
  errorMsg: string;
  statusName: BookingStatusNames | string;
  statusOptions: IBookingStatus[];
  hasPriceChanges: boolean;
  isSelectionValid: boolean;
  isOffline: boolean;
  tableSelectionList: ITableItem[];
  tableSelectionListWithJoins: ITableItem[];
  sectionsLookup: any; // object with dynamic keys
  preselectedTableIds: string[];
  state: string | State;
  tables: ITableItem[];
  selectedTableIds: string[];
}

export enum State {
  LOADING,
  ENTER,
  SUCCESS,
  ERROR,
  ERROR_LOADING,
  ERROR_CONFLICT,
  SHOW_PAYMENT_URL,
}

export interface IConfirmStandByResponse {
  status: number;
  booking: IBooking;
}
